import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ContactDetailsService } from '../contact-details.service';
import { NotificationService } from '../../shared/notification.service';
import { HistoryService } from '../contact-history/history.service';

@Component({
  selector: 'cc-contact-note',
  templateUrl: './contact-note.component.html',
  styleUrls: ['./contact-note.component.scss']
})
export class ContactNoteComponent implements OnInit {
  @Input() recordId: number;
  public note: FormControl;
  constructor(
    public contactDetailsService: ContactDetailsService,
    public notificationService: NotificationService,
    public historyService: HistoryService
  ) {}

  ngOnInit() {
    this.note = new FormControl('', Validators.required);
  }

  save() {
    this.contactDetailsService.addNote({ recordId: this.recordId, note: this.note.value }).subscribe(() => {
      this.notificationService.open('EVENT_DETAILS.NOTE_ADDED');
      this.note.setValue('');
      this.note.markAsUntouched();
      this.historyService.refreshHistory(this.recordId, '');
    });
  }
}
